import React from "react"
import { Box, Skeleton, SkeletonText } from "@chakra-ui/react"

const ProductCardSkeleton: React.FC = () => {
  return (
    <Box>
      <Skeleton
        height={{ base: "175px", md: "150px", lg: "219px" }}
        borderRadius="md"
      />
      <SkeletonText noOfLines={1} my={3} />
    </Box>
  )
}

export default ProductCardSkeleton
